import React from 'react'
import { Breadcrumbs, Button } from "@material-ui/core";
import { Assignment, Person, Place } from "@material-ui/icons";
import { MENU_TOTEM } from '../../../../utils/constants';
import { useTotem } from '../../../../hooks/useCases/useTotem';

const style = {
    root: {
      flexGrow: 1,
    },
  };

export const TotemBreadcrumb = (props) => {

    const totem = useTotem();
    const { setActiveBreadcrumb, activeBreadcrumb } = props;


    return (
      <Breadcrumbs style={{ color: "#FAFAFA" }} aria-label="breadcrumb">
        <Button
          color={
            activeBreadcrumb === MENU_TOTEM.SOLICITUDES_RECEPCIONISTA ? "default" : "inherit"
          }
          onClick={(e) => {
            setActiveBreadcrumb(MENU_TOTEM.SOLICITUDES_RECEPCIONISTA);
          }}
        >
          <Assignment className={style.icon} />
         Solicitudes Recepcionista
        </Button>
  
        <Button
           color={
              activeBreadcrumb === MENU_TOTEM.GESTION_AREAS_RECEPCIONISTA ? "default" : "inherit"
            }
          onClick={(e) => {
            setActiveBreadcrumb(MENU_TOTEM.GESTION_AREAS_RECEPCIONISTA);
          }}
        >
          <Place className={style.icon} />
          Gestión areas recepcionista
        </Button>
  
        <Button
          color={
            activeBreadcrumb === MENU_TOTEM.CARGA_SOLICITUD_AFILIADO ? "default" : "inherit"
          }
          onClick={(e) => {
            setActiveBreadcrumb(MENU_TOTEM.CARGA_SOLICITUD_AFILIADO);
            totem.clean.afiliados();
          }}
        >
          <Person className={style.icon} />
          Carga Solicitud Afiliado
        </Button>
  
      </Breadcrumbs>
    )
  }
  